import { Authenticated, CanAccess } from "@refinedev/core";
import { CatchAllNavigate } from "@refinedev/react-router-v6";
import { Outlet, Route } from "react-router-dom";
import { AccountHome } from "../pages/home/AccountHome";
import { CustomerOrderCreate } from "../pages/orders/create";
import { OrderShow } from "../pages/orders/show";
import { PaymentResult } from "../pages/payments/paymentResult";
import { TransactionList } from "../pages/transactions/list";
import { InvoiceList } from "../pages/invoices/list";
import { TarifsList } from "../pages/tarifs/list";
import { OrderList } from "../pages/orders/list";
import { ResponsiveLayout } from "../components/layout/MobileLayout";

export const CustomerRoutes = (
  <Route
    element={
      <Authenticated
        key="authenticated-inner"
        fallback={<CatchAllNavigate to="/login" />}
      >
        <CanAccess resource="account-home" action="show">
          <ResponsiveLayout>
            <Outlet />
          </ResponsiveLayout>
        </CanAccess>
      </Authenticated>
    }
  >
    <Route path="/account-home" element={<AccountHome />} />
    <Route path="/orders">
      <Route path="create" element={<CustomerOrderCreate />} />
    </Route>
    <Route path="accounts/:id">
      <Route path="orders/create" element={<CustomerOrderCreate />} />
      <Route path="orders/list" element={<OrderList />} />
      <Route path="orders/show/:id" element={<OrderShow />} />
      <Route path="tarifs/list" element={<TarifsList />} />
      <Route path="transactions/list" element={<TransactionList />} />
      <Route path="invoices/list" element={<InvoiceList />} />
    </Route>
    <Route path="payments">
      <Route path="result" element={<PaymentResult />} />
    </Route>
  </Route>
);
